import { render, staticRenderFns } from "./BadgeListDefault.vue?vue&type=template&id=7b2b8a7a&scoped=true&"
import script from "./BadgeListDefault.vue?vue&type=script&lang=js&"
export * from "./BadgeListDefault.vue?vue&type=script&lang=js&"
import style0 from "./BadgeListDefault.vue?vue&type=style&index=0&id=7b2b8a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b8a7a",
  null
  
)

export default component.exports